import React from "react";

function WorkatCareerist() {
  return <div>WorkatCareerist</div>;
}

export default WorkatCareerist;
